import { Image } from 'expo-image';
import { View } from 'react-native';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import { Card, Text } from '@/ui';

const steps = [
  'Go to Account in the app',
  'Scroll down to find partner options',
  'Tap the “Switch to Partners” button to switch views',
];

export default function GetTheApp() {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: theme.colors.background_1,
        paddingTop: 16,
      }}
    >
      <View style={styles.container}>
        <View>
          <Text type="title1">Get The Eon App</Text>

          <Text
            type="bodyRegular"
            style={{ color: theme.colors.text.secondary }}
          >
            Scan the QR code with your phone to download the app.
          </Text>
        </View>

        <View style={{ marginTop: 40 }}>
          <Text type="title2">How to Access Partner Portal in the Eon App</Text>
        </View>

        <View>
          <Card style={styles.downloadAppCard}>
            <View style={{ alignItems: 'center', gap: 16 }}>
              <Text type="bodyRegular">Download the app</Text>

              <Image
                style={{
                  width: 100,
                  height: 100,
                }}
                source={
                  UnistylesRuntime.themeName === 'dark'
                    ? require('@/../public/images/qr-onelink-dark.png')
                    : require('@/../public/images/qr-onelink-light.png')
                }
                contentFit="cover"
              />

              <Text type="bodyRegular">Available on iOS and Android</Text>
            </View>
          </Card>
        </View>

        <View style={{ gap: 16 }}>
          {steps.map((step, index) => (
            <View
              key={index}
              style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}
            >
              <View
                style={{
                  width: 24,
                  height: 24,
                  borderRadius: 12,
                  backgroundColor:
                    theme.colors.progressBar.active.backgroundColor,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Text
                  type="bodyRegular"
                  style={{ color: theme.colors.text.inverse }}
                >
                  {index + 1}
                </Text>
              </View>

              <Text type="bodyRegular" style={{ flex: 1 }}>
                {step}
              </Text>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    borderRadius: 16,
    paddingLeft: {
      xs: 16,
      md: 56,
    },
    paddingRight: {
      xs: 16,
      md: 56,
    },
    paddingTop: {
      xs: 16,
      md: 56,
    },
    gap: 16,
  },
  downloadAppCard: {
    backgroundColor: theme.colors.card.hover.backgroundColor,
    padding: 16,
    width: {
      md: 700,
    },
  },
}));
